import BaseModelAPI from '../BaseModelAPI';

export default class UserRole extends BaseModelAPI {
	static entity = 'userrole';
	static entityName = 'userrole';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.userInfoId = '';
			this.userInfo = {};
			this.userRoleDetails = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}